import { BrowserRouter, Route, Routes, Navigate, Outlet, useNavigate } from 'react-router-dom';
import Login from "../pages/login/login";
import MainDashboard from "../pages/main/MainDashboard";
import RelatorioConciliacaoSaldo from "../pages/reports/fortesAC/relatorioConciliacaoSaldo";
import Navbar from "../componentes/navbar/navbar.jsx";
import { useAuth } from "../context/authContext";
import ListaEmpregados from "../pages/reports/fortesAC/relatorioEmpregados";
import UsuarioConfig from "../pages/usuarios/UsuarioConfig";
import GrupoUsuariosCrud from "../pages/grupo-usuarios/GrupoUsuariosCrud";
import RelatorioSolicitacaoCompra from "../pages/reports/fluig/solicitacao-compras/relatorioSolicitacaoCompra";
import AlterarSenha from "../pages/login/alterarSenha";
import MeuUsuario from "../pages/meu-usuario/MeuUsuario";
import ContasPagar from "../pages/reports/fortesAG/contasPagar";
import RelatorioDespesa from "../pages/reports/fluig/lancamento-despesas/relatorioDespesas";
import { Footer } from "../componentes/footer/Footer";
import CentroCustoCrud from "../pages/centro-custo/CentroCustoCrud";
import ContaContabilCrud from "../pages/conta-contabil/ContaContabilCrud";
import ContaFinanceiraCrud from "../pages/conta-financeira/ContaFinanceiraCrud";
import InventarioTiPage from "../pages/ti-inventario/InventarioTiPage";
import CatalogosTiPage from "../pages/ti-inventario/CatalogosTiPage";
import { Config } from '../pages/config/Config';
import BPRelatorio from '../pages/bp/BPRelatorio';
import BPPage from '../pages/bp/MeuBP';
import BPPageV1 from '../pages/bp-v1/MeuBP';
import ListaTrabalhadaPage from '../pages/reports/easyPallet/DashboardListaTrabalhada';
import GerenciamentoBP from '../pages/bp/GerenciamentoBP.jsx';
import GrupoContabilCrud from '../pages/grupo-contabil/GrupoContabil.jsx';
import PaginaNaoEncontrada from '../pages/pagina-nao-encontrada/pagina-nao-encontrada.jsx';
import ContatoSuporteForm from '../pages/pagina-de-suporte/ContatoSuporteForm.jsx';
import AcessoNegado from '../pages/pagina-acesso-negado/AcessoNegado.jsx';
import RedefinirSenha from '../pages/login/RedefinirSenha.jsx';
import SolicitarResetSenha from '../pages/login/SolicitarResetSenha.jsx';
import RelatorioFrota from '../pages/reports/fleetcom/RelatorioFrota.jsx';
import RelatorioNotasVeiculos from '../pages/reports/fleetcom/RelatorioNotasVeiculos.jsx';
import EstadoCrud from '../pages/estados/EstadoCrud.jsx';
import CidadeCrud from '../pages/cidades/CidadeCrud.jsx';

import VeiculoMain from '../pages/veiculos/VeiculoMain.jsx';
import VeiculoCreate from '../pages/veiculos/VeiculoCreate.jsx';
import UsuarioVPNForm from '../pages/formularios/UsuarioVpnForm.jsx';
import EscalaDeRotaMain from '../pages/comissoes-motoristas/escala-de-rotas/EscalaDeRotaMain.jsx';
import ImportacaoMain from '../pages/comissoes-motoristas/importacao-arquivos/ImportacaoMain.jsx';
import FuncionarioMain from '../pages/funcionarios/FuncionarioMain.jsx';
import ParametrosComissao from '../pages/comissoes-motoristas/Parametros.jsx';
import Comissoes from '../pages/comissoes-motoristas/Comissoes.jsx';
import AjustesComissao from '../pages/comissoes-motoristas/ajustes/AjustesComissao.jsx';
import Faltas from '../pages/funcionarios/FaltasMain.jsx';
import DashboardSegurancaViaria from '../pages/seguranca-viaria/DashboardSegurancaViaria.jsx';
import VolumeEntregue from '../pages/volume-entregue/VolumeEntregue.jsx';
import RotasFinalizadas from '../pages/rotas-finalizadas/RotasFinalizadas.jsx';
import DashboardEntregaRetorno from '../pages/volume-entregue/DashboardEntregaRetorno.jsx';
import EventoFolha from '../pages/reports/fortesAC/EventoFolha.jsx';
import DashboardAvisoMotoristaConcept from '../pages/seguranca-viaria/DashboardAvisoMotoristaConcept.jsx';
import DashboardInfracoesCaxias from '../pages/seguranca-viaria/DashboardInfracoesCaxias.jsx';
import TelemetriaPage from '../pages/telemetria/TelemetriaPage.jsx';
import GerenciamentoMetaFilial from '../pages/bp/GerenciamentoMetaFilial.jsx';
import SincronizacaoMonitor from '../pages/monitor-sincronismo/SincronizacaoMonitor.jsx';
import MinhaComissao from '../pages/comissoes-motoristas/minha-comissao/MinhaComissao.jsx';
import TabelaCargaEntregaPhone from '../pages/comissoes-motoristas/minha-comissao/TabelaCargaEntregaPhone.jsx';
import TabelaRomaneiosPhone from '../pages/comissoes-motoristas/minha-comissao/TabelaRomaneiosPhone.jsx';
import TabelaTelemetriaPhone from '../pages/comissoes-motoristas/minha-comissao/TabelaTelemetriaPhone.jsx';
import TabelaConceptPhone from '../pages/comissoes-motoristas/minha-comissao/TabelaConceptPhone.jsx';
import TabelaAfastamentosPhone from '../pages/comissoes-motoristas/minha-comissao/TabelaAfastamentoPhone.jsx';
import { AppProvider, useApp } from '../context/appContext.jsx';
import SelecionarAplicativo from '../pages/selecionar-aplicativo/SelecionarAplicativo.jsx';
import FilialCrud from '../pages/filial/FilialCrud.jsx';
import RelatorioJornadaTrabalhada from '../pages/jornada-trabalhada/RelatorioJornadaTrabalhada.jsx';
import DashboardHorasExtras from '../pages/jornada-trabalhada/DashboardHorasExtras.jsx';
import DashboardComparativoBP from '../pages/bp/DashboardComparativoBP.jsx';
import SapEntregaVolumePage from '../pages/volume-entregue/SapEntregaVolumePage.jsx';
import GerarComissaoDL from '../pages/comissoes-motoristas/GerarComissaoDL.jsx';
import FornecedorCrud from '../pages/fornecedor/FornecedorCrud.jsx';
import TipoFornecedorCrud from '../pages/fornecedor/TipoFornecedorCrud.jsx';
import PagamentoCompensadaPage from '../pages/pagamento-compensada/PagamentoCompensadaPage.jsx';
import TipoPagamentoCrud from '../pages/tipo-pagamento/TipoPagamentoCrud.jsx';
import TipoProdutoCrud from '../pages/tipo-produto/TipoProdutoCrud.jsx';
import ProdutoCatalogoCrud from '../pages/produto-catalogo/ProdutoCatalogoCrud.jsx';
import SubCanalCrud from '../pages/sub-canal/SubCanalCrud.jsx';

import DashboardSolicitacoes from '../pages/solicitacoes/Dashboard.jsx';
import MinhasTarefas from '../pages/solicitacoes/MinhasTarefas.jsx';
import TodasSolicitacoes from '../pages/solicitacoes/TodasSolicitacoes.jsx';
import NovaSolicitacao from '../pages/solicitacoes/NovaSolicitacao.jsx';
import DetalheSolicitacao from '../pages/solicitacoes/DetalheSolicitacao.jsx';
import ConfigAtribuicoes from '../pages/solicitacoes/ConfigAtribuicoes.jsx';
import AdminTiposServicoTI from '../pages/solicitacoes/AdminTiposServicoTI.jsx';
import AdminVersoesApp from '../pages/solicitacoes/AdminVersoesApp.jsx';
import GerenciarSolicitacoes from '../pages/solicitacoes/GerenciarSolicitacoes.jsx';
import NotificacoesTodas from '../pages/solicitacoes/NotificacoesTodas.jsx';
import InicioSolicitacoes from '../pages/solicitacoes/InicioSolicitacoes.jsx';
import DashboardSolicitacaoCompras from '../pages/solicitacoes/DashboardSolicitacaoCompras.jsx';
import DashboardLancamentoDespesa from '../pages/solicitacoes/DashboardLancamentoDespesa.jsx';
import DespesasRecorrentes from '../pages/solicitacoes/DespesasRecorrentes.jsx';
import DashboardMultas from '../pages/solicitacoes/DashboardMultas.jsx';
import RelatorioPromocoes from '../pages/solicitacoes/RelatorioPromocoes.jsx';
import RelatorioDesligamento from '../pages/solicitacoes/RelatorioDesligamento.jsx';
import RelatorioSolicitacaoPessoal from '../pages/solicitacoes/RelatorioSolicitacaoPessoal.jsx';
import RelatorioChamadoTI from '../pages/solicitacoes/RelatorioChamadoTI.jsx';
import RelatorioRecolhimentoAtivos from '../pages/solicitacoes/RelatorioRecolhimentoAtivos.jsx';
import RelatorioSolicitacaoAtivos from '../pages/solicitacoes/RelatorioSolicitacaoAtivos.jsx';
import RelatorioAnaliseLimitePrazo from '../pages/solicitacoes/RelatorioAnaliseLimitePrazo.jsx';
import RelatorioCadastroCliente from '../pages/solicitacoes/RelatorioCadastroCliente.jsx';
import RelatorioAjusteGtc from '../pages/solicitacoes/RelatorioAjusteGtc.jsx';
import RelatorioRenovacaoGdm from '../pages/solicitacoes/RelatorioRenovacaoGdm.jsx';
import BaseGdm from '../pages/solicitacoes/BaseGdm.jsx';
import RelatorioConclusaoGdm from '../pages/solicitacoes/RelatorioConclusaoGdm.jsx';
import ContasAPagar from '../pages/solicitacoes/ContasAPagar.jsx';

const hasRole = (user, roles) => {
    if (!roles || roles.length === 0) return true;
    if (!user?.perfis) return false;
    return roles.some(r => user.perfis.includes(r));
};

// Adapta um ícone FontAwesome em string (formato usado por applications.js e no resto do app,
// ex. CardIndicador) pro formato que o Navbar espera (componente React, igual FaBell etc.).
function iconeDoAplicativo(classeFa) {
    return function IconeAplicativo({ className }) {
        return <i className={`${classeFa} ${className || ""}`} />;
    };
}

function RoleBasedRoute({ allowedRoles, workflows = false }) {
    const { authenticated, user } = useAuth();
    const { configAtual, aplicativoAtual, aplicativosPermitidos, trocarAplicativo } = useApp();

    if (!authenticated) {
        return <Navigate to="/login" />;
    }

    const items = configAtual.navItems();

    // Troca de aplicativo — só aparece quando há outro app pra trocar, e entra dentro do menu do
    // usuário (último item da lista, sempre o de Meu Usuário/Alterar Senha/Sair) em vez de item
    // próprio na barra.
    const outrosApps = aplicativosPermitidos.filter(app => app.key !== aplicativoAtual);
    const itensTrocarApp = outrosApps.map(app => ({
        label: `Mudar para ${app.nome}`,
        icon: iconeDoAplicativo(app.icone),
        command: () => trocarAplicativo(app.key),
    }));

    const itemsComTrocaDeApp = itensTrocarApp.length === 0 ? items : items.map((item, idx) =>
        item
    );

    const filteredItems = itemsComTrocaDeApp
        .filter(item => hasRole(user, item.roles)) // remove menu inteiro
        .map(item => ({
            ...item,
            items: item.items?.map(sub => ({
                ...sub,
                disabled: !hasRole(user, sub.roles)
            }))
        }));

    const temAcessoAoApp = aplicativosPermitidos.some(app => app.key === aplicativoAtual);

    if (temAcessoAoApp && (allowedRoles.length === 0 || allowedRoles.some(role => user.perfis.includes(role)))) {
        return (
            <>
                <Navbar items={filteredItems} homePath={configAtual.rotaInicial} workflows={workflows} />
                <Outlet />
                <Footer />
            </>
        );
    }

    return <Navigate to="/acesso-negado" replace />;
}

// Rota autenticada mas sem Navbar/Footer de nenhum aplicativo específico — usada pela tela de
// seleção, que existe justamente antes/entre os apps.
function RotaAutenticada() {
    const { authenticated } = useAuth();
    if (!authenticated) {
        return <Navigate to="/login" />;
    }
    return <Outlet />;
}

function Router() {
    return (
        <BrowserRouter>
            <AppProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/formulario-usuarios-vpn" element={<UsuarioVPNForm />} />
                    <Route path="/redefinir-senha/:email" element={<RedefinirSenha />} />
                    <Route path="/solicitar-senha" element={<SolicitarResetSenha />} />
                    <Route path='/*' element={<PaginaNaoEncontrada />} />
                    <Route path='/contato-suporte' element={<ContatoSuporteForm />} />
                    <Route path='/acesso-negado' element={<AcessoNegado />} />

                    {/* Seleção de aplicativo — autenticado, mas fora do Navbar/Footer de qualquer app específico */}
                    <Route element={<RotaAutenticada />}>
                        <Route path="/selecionar-aplicativo" element={<SelecionarAplicativo />} />
                        <Route path="/" element={<SelecionarAplicativo />} />
                    </Route>

                    {/* Acesso geral para usuários autenticados */}
                    <Route element={<RoleBasedRoute allowedRoles={[]} />}>
                        <Route path="/bi" element={<MainDashboard />} />
                        <Route path="/alterar-senha" element={<AlterarSenha />} />
                        <Route path="/alteracao-senha" element={<AlterarSenha />} />
                        <Route path="/meu-usuario" element={<MeuUsuario />} />
                    </Route>

                    {/* Contabilidade */}
                    <Route element={<RoleBasedRoute allowedRoles={['CONTADOR', 'ADMIN']} />}>
                        <Route path="/conciliacao-de-saldos" element={<RelatorioConciliacaoSaldo />} />
                        <Route path="/prestacao-contas" element={<ContasPagar />} />
                        <Route path="/pagamento-compensadas" element={<PagamentoCompensadaPage />} />

                        <Route path="/centro-custo" element={<CentroCustoCrud />} />
                        <Route path="/centro-custo/new" element={<CentroCustoCrud />} />
                        <Route path="/centro-custo/edit/:codigo" element={<CentroCustoCrud />} />

                        <Route path="/grupo-contabil" element={<GrupoContabilCrud />} />
                        <Route path="/grupo-contabil/new" element={<GrupoContabilCrud />} />
                        <Route path="/grupo-contabil/edit/:codigo" element={<GrupoContabilCrud />} />

                        <Route path="/conta-contabil" element={<ContaContabilCrud />} />
                        <Route path="/contas/new" element={<ContaContabilCrud />} />
                        <Route path="/contas/edit/:codigo" element={<ContaContabilCrud />} />
                        <Route path="/conta-financeira" element={<ContaFinanceiraCrud />} />
                        <Route path="/metas" element={<GerenciamentoMetaFilial />} />

                        <Route path="/bp/gerenciamento" element={<GerenciamentoBP />} />
                        <Route path="/solicitacoes/fornecedores" element={<FornecedorCrud />} />
                        <Route path="/solicitacoes/tipo-pagamentos" element={<TipoPagamentoCrud />} />
                        <Route path="/solicitacoes/tipo-fornecedores" element={<TipoFornecedorCrud />} />
                    </Route>

                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'DIRETOR']} />}>
                        <Route path="/bp/v1/2026" element={<BPPage />} />
                        <Route path="/bp/2026" element={<BPPageV1 />} />
                        <Route path="/bp/comparativo" element={<DashboardComparativoBP />} />
                    </Route>

                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'BP']} />}>
                        <Route path="/acompanhamento-bp" element={<BPRelatorio />} />
                        <Route path="/acompanhamento-bp/2025" element={<BPRelatorio />} />
                    </Route>

                    {/* Recursos Humanos */}
                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'RH']} />}>
                        <Route path="/filiais" element={<FilialCrud />} />
                        <Route path="/motoristas" element={<ListaEmpregados />} />
                    </Route>

                    {/* Logística */}
                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'LOGISTICA']} />}>
                        <Route path="/filiais" element={<FilialCrud />} />
                        <Route path="/motoristas" element={<ListaEmpregados />} />
                        <Route path="/montagem-de-cargas" element={<ListaTrabalhadaPage />} />
                        <Route path="/frota" element={<RelatorioFrota />} />
                        <Route path="/notas-veiculos" element={<RelatorioNotasVeiculos />} />
                        <Route path="/parametros-comissoes" element={<ParametrosComissao />} />
                    </Route>

                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'COMISSOES', 'RH']} />}>
                        <Route path="/escalas-de-rotas" element={<EscalaDeRotaMain />} />
                        <Route path="/funcionarios" element={<FuncionarioMain />} />
                        <Route path="/seguranca-viaria" element={<DashboardSegurancaViaria />} />
                        <Route path="/seguranca-viaria/da" element={<DashboardAvisoMotoristaConcept />} />
                        <Route path="/infracoes-motoristas/caxias" element={<DashboardInfracoesCaxias />} />
                        <Route path="/comissoes" element={<Comissoes />} />
                        <Route path="/gerar-comissao" element={<GerarComissaoDL />} />

                    </Route>

                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'COMISSOES', 'RH']} />}>
                        <Route path="/escalas-de-rotas" element={<EscalaDeRotaMain />} />
                        <Route path="/funcionarios" element={<FuncionarioMain />} />
                        <Route path="/veiculos" element={<VeiculoMain />} />
                        <Route path="/veiculos/p" element={<VeiculoCreate />} />
                        <Route path="/veiculos/p/:id" element={<VeiculoCreate />} />
                        <Route path="/seguranca-viaria" element={<DashboardSegurancaViaria />} />
                        <Route path="/comissoes" element={<Comissoes />} />
                        <Route path="/volume-entregue" element={<VolumeEntregue />} />
                        <Route path="/rotas-finalizadas" element={<RotasFinalizadas />} />
                    </Route>

                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'BP', 'COMISSOES', 'CONTABILIDADE', 'DIRETOR', 'LOGISTICA', 'RH']} />}>
                        <Route path="/dashboard-entregas-retornos" element={<DashboardEntregaRetorno />} />
                    </Route>

                    {/* Administração e RH */}
                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'RH']} />}>
                        <Route path="/ajustes-comissoes" element={<AjustesComissao />} />
                        <Route path="/faltas" element={<Faltas />} />
                        <Route path="/eventos-folhas" element={<EventoFolha />} />
                        <Route path="/jornada-trabalhada" element={<RelatorioJornadaTrabalhada />} />
                        <Route path="/jornada-trabalhada/horas-extras" element={<DashboardHorasExtras />} />
                    </Route>

                    {/* Administração */}
                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN']} />}>
                        <Route path="/telemetria" element={<TelemetriaPage />} />
                        <Route path="/configuracoes" element={<Config />} />
                        <Route path="/usuarios" element={<UsuarioConfig />} />
                        <Route path="/grupos-usuarios" element={<GrupoUsuariosCrud />} />
                        <Route path="/estados" element={<EstadoCrud />} />
                        <Route path="/cidades" element={<CidadeCrud />} />
                        <Route path="/faltas" element={<Faltas />} />
                        <Route path="/importacao-arquivos" element={<ImportacaoMain />} />
                        <Route path="/monitor-sincronismo" element={<SincronizacaoMonitor />} />
                        <Route path="/solicitacoes/usuarios" element={<UsuarioConfig />} />
                        <Route path="/solicitacoes/grupos-usuarios" element={<GrupoUsuariosCrud />} />
                        <Route path="/ti/inventario" element={<InventarioTiPage />} />
                        <Route path="/ti/catalogos" element={<CatalogosTiPage />} />
                    </Route>

                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'MOTORISTA', 'AUXILIAR_ENTREGA']} />}>
                        <Route path="/minha-comissao" element={<MinhaComissao />} />
                        <Route path="/minha-comissao/cargas" element={<TabelaCargaEntregaPhone />} />
                        <Route path="/minha-comissao/romaneios" element={<TabelaRomaneiosPhone />} />
                        <Route path="/minha-comissao/telemetria-greenmile" element={<TabelaTelemetriaPhone />} />
                        <Route path="/minha-comissao/telemetria-concept" element={<TabelaConceptPhone />} />
                        <Route path="/minha-comissao/afastamentos" element={<TabelaAfastamentosPhone />} />
                    </Route>

                    {/* Suprimentos */}
                    <Route element={<RoleBasedRoute allowedRoles={['ADMIN', 'SUPRIMENTOS']} />}>
                        <Route path="/solicitacao-de-compras" element={<RelatorioSolicitacaoCompra />} />
                        <Route path="/lancamento-de-despesa" element={<RelatorioDespesa />} />
                        <Route path="/solicitacoes/contas-a-pagar" element={<ContasAPagar />} />
                    </Route>

                    {/* Solicitações (workflow/BPM) */}
                    <Route element={<RoleBasedRoute workflows={true} allowedRoles={[]} />}>
                        <Route path="/solicitacoes" element={<InicioSolicitacoes />} />
                        <Route path="/solicitacoes/inicio" element={<InicioSolicitacoes />} />
                        <Route path="/solicitacoes/central-tarefas" element={<MinhasTarefas />} />
                        <Route path="/solicitacoes/todas" element={<TodasSolicitacoes />} />
                        <Route path="/solicitacoes/notificacoes" element={<NotificacoesTodas />} />
                        <Route path="/solicitacoes/nova" element={<NovaSolicitacao />} />
                        <Route path="/solicitacoes/despesas-recorrentes" element={<DespesasRecorrentes />} />
                        <Route path="/solicitacoes/relatorios/compras" element={<DashboardSolicitacaoCompras />} />
                        <Route path="/solicitacoes/relatorios/despesa" element={<DashboardLancamentoDespesa />} />
                        <Route path="/solicitacoes/relatorios/multas" element={<DashboardMultas />} />
                        <Route path="/solicitacoes/relatorios/promocoes" element={<RelatorioPromocoes />} />
                        <Route path="/solicitacoes/relatorios/desligamento" element={<RelatorioDesligamento />} />
                        <Route path="/solicitacoes/relatorios/solicitacao-pessoal" element={<RelatorioSolicitacaoPessoal />} />
                        <Route path="/solicitacoes/relatorios/chamados-ti" element={<RelatorioChamadoTI />} />
                        <Route path="/solicitacoes/relatorios/recolhimento-ativos" element={<RelatorioRecolhimentoAtivos />} />
                        <Route path="/solicitacoes/relatorios/solicitacao-ativos" element={<RelatorioSolicitacaoAtivos />} />
                        <Route path="/solicitacoes/relatorios/analise-limite-prazo" element={<RelatorioAnaliseLimitePrazo />} />
                        <Route path="/solicitacoes/relatorios/cadastro-cliente" element={<RelatorioCadastroCliente />} />
                        <Route path="/solicitacoes/relatorios/ajuste-gtc" element={<RelatorioAjusteGtc />} />
                        <Route path="/solicitacoes/relatorios/renovacao-gdm" element={<RelatorioRenovacaoGdm />} />
                        <Route path="/solicitacoes/base-gdm" element={<BaseGdm />} />
                        <Route path="/solicitacoes/:id" element={<DetalheSolicitacao />} />
                        <Route path="/solicitacoes/meu-usuario" element={<MeuUsuario />} />
                        <Route path="/solicitacoes/alterar-senha" element={<AlterarSenha />} />
                    </Route>

                    
                    <Route element={<RoleBasedRoute workflows={true} allowedRoles={['ADMIN', 'ANALISTA']} />}>
                        <Route path="/solicitacoes/relatorios/conclusao-gdm" element={<RelatorioConclusaoGdm />} />
                    </Route>


                    <Route element={<RoleBasedRoute workflows={true} allowedRoles={['ADMIN', 'SUPRIMENTOS']} />}>
                        <Route path="/solicitacoes/config/tipos-produto" element={<TipoProdutoCrud />} />
                        <Route path="/solicitacoes/config/produtos" element={<ProdutoCatalogoCrud />} />
                    </Route>

                    <Route element={<RoleBasedRoute workflows={true} allowedRoles={['ADMIN']} />}>
                        <Route path="/solicitacoes/config/atribuicoes" element={<ConfigAtribuicoes />} />
                        <Route path="/solicitacoes/config/tipos-servico-ti" element={<AdminTiposServicoTI />} />
                        <Route path="/solicitacoes/config/versoes-app" element={<AdminVersoesApp />} />
                        <Route path="/solicitacoes/config/gerenciar" element={<GerenciarSolicitacoes />} />
                        <Route path="/solicitacoes/config/subcanais" element={<SubCanalCrud />} />
                    </Route>
                </Routes>
            </AppProvider>
        </BrowserRouter>
    );
}

export default Router;